import logUtil from 'utils/log'
import toggleAddRemoveProductCartAction from 'modules/cart/redux/actions/toggle-add-remove'
import { shouldShowAOVLockProductVariantSelector } from 'modules/product-variant/redux/selectors/should-show-aov-lock'
import openModalAction from 'modules/modal/redux/actions/open'
import { MODAL_ID } from 'modules/modal/redux/constants'

const ANALYTICS_EVENT = {
  UNLOCK_PRODUCT_BUTTON: 'UNLOCK_PRODUCT_BUTTON',
  VIEW_PRODUCT_OPTIONS: 'VIEW_PRODUCT_OPTIONS'
}

/**
 * @param e
 * @param logPrefix
 * @param shouldUnlock
 * @param isDisabled
 * @param openUnlockTierSidebar
 * @param logEvent
 * @param hasVariants
 * @param shouldShowQuickShades
 * @param shouldShowVariants
 * @param isInCart
 * @param props
 * @param variantId
 * @param {ProductVariantCollection} productVariant
 * @param analyticEventPrefix
 * @param shouldShowFullSizeConversion
 * @param openProductSidebar
 * @returns {(function(*, *): Promise<void>)|*}
 */
const handleClickAddButtonProductCollectionItemAction = ({
  e,
  logPrefix,
  shouldUnlock,
  isDisabled,
  openUnlockTierSidebar,
  logEvent,
  hasVariants,
  shouldShowQuickShades,
  shouldShowVariants,
  isInCart,
  props,
  variantId,
  productVariant,
  analyticEventPrefix,
  shouldShowFullSizeConversion,
  openProductSidebar
}) => {
  return async (dispatch, getState) => {
    e.preventDefault()
    e.stopPropagation()

    logUtil('ProductCollectionItem#handleClickAddButton').debug(`${logPrefix} [start]`)

    if (isDisabled) {
      return
    }

    if (shouldUnlock) {
      logEvent(ANALYTICS_EVENT.UNLOCK_PRODUCT_BUTTON)
      openUnlockTierSidebar()
      return
    }

    const aovLock = productVariant?.aov_lock
    const shouldShowAovLock = shouldShowAOVLockProductVariantSelector({
      productVariant
    })(getState())
    if (shouldShowAovLock) {
      dispatch(
        openModalAction(MODAL_ID.PRODUCT_AOV_LOCK, {
          aovLock
        })
      )
      return
    }

    if (
      hasVariants &&
      !shouldShowQuickShades &&
      shouldShowVariants
    ) {
      logEvent(ANALYTICS_EVENT.VIEW_PRODUCT_OPTIONS)
      openProductSidebar()
      return
    }

    if (
      !isInCart &&
      props?.beforeOnClickAdd?.() === false
    ) {
      logUtil('ProductCollectionItem#handleClickAddButton').debug(`${logPrefix} [noop] beforeOnClickAdd`)
      return
    }

    await dispatch(
      toggleAddRemoveProductCartAction({
        variantId,
        onClickAdd: props.onClickAdd,
        productVariant,
        analyticEventPrefix,
        shouldShowFullSizeConversion
      })
    )
  }
}

export default handleClickAddButtonProductCollectionItemAction
